import React, { useEffect, useState, useContext } from "react";
import Rating from "@mui/material/Rating";
import axios from "axios";

import Button from "@mui/material/Button";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Snackbar from '@mui/material/Snackbar';
import { AuthContext } from '../../context/AuthContext';

import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ENDPOINT from "../../data/ENDPOINT";


const SellToolDetails = () => {
  const { user, cartCount, setCartCount } = useContext(AuthContext);
  const [tools, setTools] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');


  const { tool_id } = useParams();

  const AddToCart = async () => {

     if(user == null || user == 'null'){
      setMessage("You need to login to add items to cart.");
      setOpen(true);
    
      
      if (window.confirm("You need to login to add items to cart.\n\nPress OK to login or Cancel to stay.")) {
        window.location.replace('/login');
      }
      return;
    
    }
    const data = new FormData();
    if(user !== null || user !== 'null'){
        data.append('session', user.SessionId)

    }
    data.append('sell_tool_id', tool_id);
    const response = await axios.post(
      `${ENDPOINT}sell-tool-add-to-cart.php`,
      data,
      { "header": { "content-type": "multipart/formdata" } }
    );
    if (response) {
      console.log(response.data);
      setOpen(true);
      setMessage(response.data.message);
      if (response.data.status === "success") {
        setTools(response.data.data);
        setCartCount(cartCount + 1)
     
      }
    }
  };

  const getDetails = async () => {
    const data = new FormData();
    data.append('tool_id', tool_id);

    const response = await axios.post(
      `${ENDPOINT}get-sell-tool-details.php`,
      data,
      { "header": { "content-type": "multipart/formdata" } }
    );

    if (response) {
      console.log(response.data);
      if (response.data.status === "success") {
        setTools(response.data.data[0]);
      }
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={() => setOpen(false)}
        message={message}
      />

      <div className="container col-12 d-flex my-5 flex-lg-row flex-column align-items-lg-start align-items-center">
        {tools ? (
          <>
            <div className="col-lg-4 col-md-5 col-sm-7 col-xl-3 p-2 first-section mx-auto ">
              <div className=" " style={{ height: "70vh," }}>
                <iframe
                  width="320"
                  height="510"
                  className="w-100 border shadow rounded-3"
                  src={tools.youtube_video_link}
                  title="Embed a Youtube video using HTML using iframe tag #viral #shorts #javascript #html"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="col-lg-8 container px-5 col-12 mt-4">
          <h1 className="text-start">
            <span className="text-primary">{tools.tool_name}</span> Description: {cartCount}
          </h1>
          <hr />
          <div className="text-start">
            <p className="fs-5 ">{tools.tool_description}</p>

            <h3 className="mt-2 text-success">₹50</h3>
            {""}

            <Rating
              style={{ paddingTop: "10px" }}
              name="half-rating-read"
              defaultValue={2.5}
              precision={0.5}
              readOnly
            />

            <div>
              <Button
                onClick={(e) => AddToCart(true)}
                className="mt-4 "
                variant="contained"
                endIcon={<ShoppingCartIcon />}
              >
                Add to Cart
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellToolDetails;
